import moment from 'moment';

export function formatToMilitary(time: string): string {
  if (!time) return '';
  return moment(time, 'h:mm A').format('HH:mm');
}

export function formatToAmPm(time: string): string {
  if (!time) return '';
  return moment(time, 'HH:mm').format('h:mm A');
}
